import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function E() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('RV');

    const isUsCa = ['us', 'ca'].includes(locale);

    return (
        <div id="RV-E" className={`RV-E RV-box ${css['RV-E']}`}>
            <div className="info-box">
                <p className="title">
                    {t.rich('E_title', {
                        b: (text: string) => <span className="blue">{text}</span>,
                    })}
                </p>
            </div>
            <div className={`features pc ${isUsCa ? 'us-ca' : ''}`}>
                <div className="left box">
                    <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075643856/5_1.png'} alt={t('E_text1')} />
                    <p className="text">
                        {t.rich('E_text1', {
                            s: (text: string) => <span className="s">{text}</span>,
                        })}
                    </p>
                </div>
                <div className="right">
                    <div className="r-t">
                        <div className="r-t-l box">
                            <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075702133/5_2.png'} alt={t('E_text2')} />
                            <p className="text">
                                {t.rich('E_text2', {
                                    s: (text: string) => <span className="s">{text}</span>,
                                })}
                            </p>
                        </div>
                        <div className={`r-t-r box ${isUsCa ? 'us-ca' : ''}`}>
                            <EFPicture
                                src={
                                    !isUsCa
                                        ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075770394/5_3.png'
                                        : 'https://websiteoss.ecoflow.com/upload/image/1744683966058/PC_3.png'
                                }
                                alt={t('E_text3')}
                            />
                            <div className="text-box">
                                <p className="text">{t('E_text3')}</p>
                                {!isUsCa && (
                                    <>
                                        <p className="blue-bar"></p>
                                        <p className="bar-text">{t('E_text3_d1')}</p>
                                        <p className="gray-bar"></p>
                                        <p className="bar-text">{t('E_text3_d2')}</p>
                                        <p className="bar-tip">{t('E_text3_tip')}</p>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="r-b">
                        <div className="r-b-l box">
                            <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075802227/5_4.png'} alt={t('E_text4')} />
                            <p className="text">{t('E_text4')}</p>
                        </div>
                        <div className="r-b-m box">
                            <EFPicture
                                src={
                                    'kr' == locale
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1720682333759/5_5_pc_kr.png'
                                        : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075828595/5_5.png'
                                }
                                alt={t('E_text5')}
                            />
                            <p className="text">{t('E_text5')}</p>
                            <p className="text desc">{t('E_text5_desc')}</p>
                        </div>
                        <div className="r-b-r box">
                            <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075889025/5_6.png'} alt={t('E_text6')} />
                            <p className="text">{t('E_text6')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`features h5 ${isUsCa ? 'us-ca' : ''}`}>
                <div className="l1 box">
                    <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075668177/5_1_M.png'} alt={t('E_text1')} />
                    <p className="text">
                        {t.rich('E_text1', {
                            s: (text: string) => <span className="s">{text}</span>,
                        })}
                    </p>
                </div>
                <div className="l2">
                    <div className="l2-l box">
                        <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075737725/5_2_M.png'} alt={t('E_text2')} />
                        <p className="text">
                            {t.rich('E_text2', {
                                s: (text: string) => <span className="s">{text}</span>,
                            })}
                        </p>
                    </div>
                    <div className="l2-r box">
                        <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075786076/5_3_M.png'} alt={t('E_text4')} />
                        <p className="text">{t('E_text4')}</p>
                    </div>
                </div>
                <div className={`l3 box ${isUsCa ? 'us-ca' : ''}`}>
                    <EFPicture
                        src={
                            !isUsCa
                                ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075815374/5_4_M.png'
                                : 'https://websiteoss.ecoflow.com/upload/image/1744786473314/o_h5.jpg'
                        }
                        alt={t('E_text3')}
                    />
                    <div className="text-box">
                        <p className="text">{t('E_text3')}</p>
                        {!isUsCa && (
                            <>
                                <p className="blue-bar"></p>
                                <p className="bar-text">{t('E_text3_d1')}</p>
                                <p className="gray-bar"></p>
                                <p className="bar-text">{t('E_text3_d2')}</p>
                                <p className="bar-tip">{t('E_text3_tip')}</p>
                            </>
                        )}
                    </div>
                </div>
                <div className="l4">
                    <div className="l4-l box">
                        <EFPicture
                            src={
                                'kr' == locale
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1720682697871/5_5_h5_kr.png'
                                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075871508/5_5_M.png'
                            }
                            alt={t('E_text5')}
                        />
                        <p className="text">{t('E_text5')}</p>
                        <p className="text desc">{t('E_text5_desc')}</p>
                    </div>
                    <div className="l4-r box">
                        <EFPicture src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075841190/5_6_M.png'} alt={t('E_text6')} />
                        <p className="text">{t('E_text6')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
